export default __webpack_public_path__ + "static/media/photo2.89aa4f4a.jpg";